import React, { Component } from "react";
import CogList from "./CogList";
import CogAddEdit from "./CogAddEdit";

class Cog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
    //this.handleLogoffClick = this.handleLogoffClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <CogList onClick={this.handleClick} />;
    } else {
      return (
        <CogAddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data });
    //else this.setState({ data: pData });
    this.setState({ mode });
  }
}

export default Cog;
